import React from 'react';
import { Alert } from 'react-bootstrap';

const FunnelHasNoPages = (): React.ReactElement => {
  return (
    <Alert variant="warning">
      <Alert.Heading>Keine Seiten gefunden</Alert.Heading>
      <p>Wenn dies dein Funnel ist, logge dich in dein Dashboard ein und füge Seiten hinzu.</p>
    </Alert>
  );
};

export default FunnelHasNoPages;
